import DragObject2DElement from './drag-object-2d-element.js';
import Region2DElement from './region-2d-element.js';
import Mouse2DPointer from './mouse-2d-pointer.js';
import Event from '../utils/event.js';

import DragDrop from './drag-drop.js';

class DragDrop2DElements {
    constructor(onChange) {
        this._domObjects = new Map();

        this._getDomObject = (domElement) => {
            while (domElement) {
                let object = this._domObjects.get(domElement);
                if (object) {
                    return object;
                }

                domElement = domElement.parentElement;
            }
        };

        this._objects = new Map();
        this._regions = new Map();

        this._pointer = new Mouse2DPointer(this._getDomObject);
        this._pointer.init();

        this._onEnterEventThis = this._onEnterEvent.bind(this);
        this._onResetEventThis = this._onResetEvent.bind(this);
        this._dragDrop = new DragDrop(this._pointer);
        this._dragDrop.enterEvent.listen(this._onEnterEventThis);
        this._dragDrop.resetEvent.listen(this._onResetEventThis);

        this.enterEvent = new Event(); // { region, object }
        this.resetEvent = new Event(); // { object }

        this.onChange = onChange;
    }

    dispose() {
        this._dragDrop.enterEvent.unlisten(this._onEnterEventThis);
        this._dragDrop.resetEvent.unlisten(this._onResetEventThis);
        this._dragDrop.dispose();

        this._pointer.uninit();
    }

    resetPositions() {
        this._dragDrop.resetPositions();
    }

    resetPosition(object2d) {
        let object = this._objects.get(object2d);
        this._dragDrop.resetPosition(object);
    }

    addObject(object2d) {
        let object = new DragObject2DElement(object2d);
        this._domObjects.set(object2d.domElement, object);

        this._objects.set(object2d, object);
        this._dragDrop.addObject(object);
    }

    removeObject(object2d) {
        let object = this._objects.get(object2d);

        this._dragDrop.removeObject(object);
        this._objects.delete(object2d);

        this._domObjects.delete(object2d.domElement);
    }

    addRegion(region2d) {
        let region = new Region2DElement(region2d);

        this._regions.set(region2d, region);
        this._dragDrop.addRegion(region);
    }

    removeRegion(region2d) {
        let region = this._regions.get(region2d);

        this._dragDrop.removeRegion(region);
        this._regions.delete(region2d);
    }

    getObjectRegion(object2d) {
        let object = this._objects.get(object2d);
        let region = this._dragDrop.getObjectRegion(object);
        return region && region.getObject();
    }

    getRegionObject(region2d) {
        let region = this._regions.get(region2d);
        let object = this._dragDrop.getRegionObject(region);
        return object && object.getObject();
    }

    _onEnterEvent({ region, object }) {
        let object2d = object.getObject();
        let region2d = region.getObject();
        this.enterEvent.fire({ region: region2d, object: object2d });
        if (typeof this.onChange === "function") {
            this.onChange(this._dragDrop._regionObject.size, object2d, region2d)
        }
    }

    _onResetEvent({ object }) {
        let object2d = object.getObject();

        this.resetEvent.fire({ object: object2d });
        if (typeof this.onChange === "function") {
            this.onChange(this._dragDrop._regionObject.size, object2d, null)
        }
    }
}

export default DragDrop2DElements;
